var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReversal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5388_15631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42751 21.8308V20.2208C4.42499 19.162 4.63135 18.1132 5.03477 17.1343C5.43819 16.1554 6.03075 15.2657 6.77852 14.5162C7.52628 13.7666 8.41456 13.172 9.39248 12.7662C10.3704 12.3605 11.4188 12.1516 12.4775 12.1516H41.515",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.03 6.95752L42.2434 12.1517L37.03 17.365",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1666 24.3992V26.0283C42.1666 27.0871 41.9577 28.1355 41.552 29.1134C41.1462 30.0913 40.5516 30.9796 39.802 31.7273C39.0525 32.4751 38.1628 33.0677 37.1839 33.4711C36.205 33.8745 35.1562 34.0809 34.0974 34.0783H5.15576",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62166 39.2918L4.42749 34.0784L9.62166 28.8843",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5388_15631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReversal);
export default __webpack_public_path__ + "static/media/reversal.209efd97d411282b90fb9d8a328361be.svg";
export { ForwardRef as ReactComponent };